/* eslint-disable @typescript-eslint/default-param-last */
import { initialState } from '../default/properties';
import { PROPERTIES_SET_EYE_DIRECTION, PROPERTIES_SET_LIGHT_DIRECTION, PROPERTIES_UPDATE_PROPERTY } from './actions';
import dotProp from 'dot-prop-immutable';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PROPERTIES_SET_LIGHT_DIRECTION: {
      return {
        ...state,
        light: {
          ...state.light,
          lightDirectionX: action.payload[0],
          lightDirectionY: action.payload[1],
          lightDirectionZ: action.payload[2],
        },
      };
    }

    case PROPERTIES_SET_EYE_DIRECTION: {
      return {
        ...state,
        light: {
          ...state.light,
          eyeDirectionX: action.payload[0],
          eyeDirectionY: action.payload[1],
          eyeDirectionZ: action.payload[2],
        },
      };
    }

    case PROPERTIES_UPDATE_PROPERTY: {
      return dotProp.set(state, action.payload.key, action.payload.value);
    }

    default:
      return state;
  }
};

export default reducer;
